<div class="form-footer">
  <button
    *ngIf="exibirExcluir"
    type="button"
    class="btn btn-danger crud-footer-btn"
    [disabled]="excluirDesabilitado"
    (click)="excluir.emit()">
    Excluir
  </button>
  <button type="button" class="btn btn-primary crud-footer-btn" (click)="limpar.emit()">
    <i class="bi bi-x-lg px-2"></i>Limpar
  </button>
  <button type="button" class="btn btn-success crud-footer-btn" (click)="salvar.emit()">
    <i class="bi bi-floppy px-2"></i>Salvar
  </button>
</div>
